import { render, staticRenderFns } from "./CivilProceedingsSurvey.vue?vue&type=template&id=6761dda5"
import script from "./CivilProceedingsSurvey.vue?vue&type=script&lang=ts"
export * from "./CivilProceedingsSurvey.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports